import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit.jsx";
import Foot from "../../../../components/Math/Units/Imperial/Foot.jsx";
import Metre from "../../../../components/Math/Units/Metric/Metre.jsx";
import { NumberFormatText } from "../../../../components/NumberFormatText.jsx";
import { RowBody } from "../../../../components/RowValue/RowBody.jsx";
import { selectTotalLength } from "../../../../store/slices/fhwaSlice.js";

function TotalLength() {
  const { t } = useTranslation("translation");

  const totalLength = useSelector(selectTotalLength);

  return (
    <RowBody
      titleValue={<p>{t("aashto.ausser.Total Length")}</p>}
      inputValue={
        <span className="input">
          <NumberFormatText value={totalLength.current} decimalScale={2} />
        </span>
      }
      unitValue={<ConvertUnit Metric={<Metre />} Imperial={<Foot />} />}
    />
  );
}

export default TotalLength;
